import { type FC } from 'react'

import { useAtomValue } from 'jotai'

import { devMocksStatusAtom } from './devMocks.store'

const BADGE_CLASSNAME = 'fixed bottom-4 left-[68px] z-40 rounded border px-3 py-1 text-xs'

/**
 * Tells that the TVM → BO pages show fixtures, not backend data (risk: a fixture taken for a real
 * record during a review), or that the mocks were requested but did not start (risk: the opposite,
 * a reviewer who thinks the mocks are on). Rendered only when the flag is on.
 *
 * English and hardcoded on purpose, like the Testing Panel: it only exists in `testingTooling`
 * environments, never in PROD, and the CMS catalogue has no key for it (`t()` would print the raw
 * key). Bottom left, past the 52px side menu rail: the Testing Panel owns the bottom centre.
 */
export const DevMocksBadge: FC = () => {
  const status = useAtomValue(devMocksStatusAtom)

  if (status === 'active') {
    return (
      <output className={`${BADGE_CLASSNAME} border-amber-300 bg-amber-100 text-amber-900`}>
        Mocked data: TVM → BO pages do not reflect the backend
      </output>
    )
  }

  if (status === 'failed') {
    return (
      <div role="alert" className={`${BADGE_CLASSNAME} border-red-300 bg-red-100 text-red-900`}>
        Mocked data requested but not started: reload the page to retry (see the console)
      </div>
    )
  }

  return null
}
